import React, { Component } from "react";
import { connect } from "react-redux";
import { formatRoute } from "react-router-named-routes";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PopoverBody,
  PopoverHeader,
  UncontrolledPopover,
} from "reactstrap";
import Notification from "../Components/Notification";
import profile_image from "../Images/profile-image.png";
import decodeJWT from "../lib/decodeJWT";
import { UserServices } from "../Services/User";
import {
  displayName,
  loginUserFailure,
  loginUserSuccess,
  openSearchBar,
} from "../Store/Actions/User";
import constants from "../Utils/constants";
import DateTimeFormatter from "../Utils/DateTimeFormatter";
import Toast from "../Utils/Toast";
import ToggleSwitch from "../Components/ToggleSwitch";
import CustomReactTooltip from "../Components/CustomReactTooltip";
import ellipsisName from "../Utils/AddEllipsisToName";
import HeaderNotification from "./HeaderNotification";
import { ApiCredentialServices } from "../Services/ApiCredentialServices";
import Copy from "../Utils/Copy";
import AclAction from "../Components/ACL/AclAction";
import PasswordChecklist from "react-password-checklist";
import React_GA_Intialise from "../Utils/InitializeGa";
import ReactGA from "react-ga4";
import SamlConfiguration from "./SamlConfiguration/SamlConfiguration";
import SAML_CONSTANTS from "./SamlConfiguration/utils/constants";
import MagicLinkTimer from "./MagicLink/MagicLinkTimer";
import DailogNew from "../Components/DailogNew";
import moment from "moment";
import { MagicLinkUserServices } from "./MagicLink/Services/MagicLinkUserServices";
import { getFirstLetters } from "../Helpers/Helper";
import { WebSocketConsumer } from "../Providers/WebSocketContext";
import { HeaderNotificationService } from "../Services/HeaderNotification";
import { notifications } from "../Store/Actions/Notifications";
import { refreshAccessToken } from "../lib/axios";

class Header extends Component {
  state = {
    loginSuccessData: null,
    isProfileMenu: false,
    popUpModel: false,
    popUpNameModel: false,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    apiErrors: "",
    formErrors: {},
    passwordError: false,
    isSubmitted: false,
    successMessage: "",
    newDisplayName: "",
    displayName_id: null,
    isTrueVal: false,
    display_name: localStorage.getItem("display_name"),
    popUpApiCredentials: false,
    clientId: null,
    userId: null,
    APIKey: null,
    secretKey: null,
    showNotification: true,
    is_user_active: false,
    isChecklistValid: false,
    isNewPasswordCurrentPasswordEqualError: false,
    showSamlConfig: false,
    isExpirationModalOpen: false,
    dailogModalHeader: "",
    dailogModalContent: "",
    dailogModalConfig: { type: null },
    submitButtonLabel: "Confirm",
    confirmBtn: true,
    cancelBtn: true,
  };

  constructor(props) {
    super(props);
    this.countdown = 5; // Start countdown from 5 seconds
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.timerId = null;
  }

  componentDidMount() {
    const { socketRef } = this.props;

    let tokenDetails = decodeJWT(localStorage.getItem("token"));

    // ✅ Now attach the listener (AFTER defining the handler)
    if (socketRef?.current) {
      socketRef.current.on("client-event", this.handleSocketMessage);
    } else {
      // ⏳ Wait for a socket connection to initialize
      this.waitForSocket();
    }

    const loginSuccessData = this.props.home.loginUserSuccess;
    let displayName =
      this.state.display_name === "null"
        ? loginSuccessData.first_name
        : this.state.display_name;
    this.props.setDisplayName(displayName);

    (async () => {
      await this.getNotificationList(); // no need for async IIFE here either
    })();

    // Handle Magic Link Expiry
    if (
      tokenDetails?.user?.auth_type === "MAGIC_LINK" &&
      tokenDetails?.user?.expire_in
    ) {
      const expiryTime = moment.utc(tokenDetails?.user?.expire_in).local();

      this.tokenExpiryInterval = setInterval(() => {
        const now = moment();
        const role = tokenDetails?.role?.short_name;

        if (now.isAfter(expiryTime)) {
          clearInterval(this.tokenExpiryInterval);

          if (role === "client_admin" || role === "client_super_admin") {
            (async () => {
              await refreshAccessToken(null);
            })();
          } else {
            this.setState({
              dailogModalHeader: (
                <span
                  className="text-darkblue2 font-weight-bold"
                  style={{ fontSize: "1.125rem" }}
                >
                  Link is Expired
                </span>
              ),
              dailogModalContent: (
                <p className="text-darkblue2" style={{ fontSize: "14px" }}>
                  The magic link has expired. Click 'Request Now' to request a
                  renewed link.
                </p>
              ),
              isExpirationModalOpen: true,
              dailogModalConfig: { type: "magic-link-expired" },
              submitButtonLabel: "Request Now",
            });
          }
        }
      }, 1000);
    }

    this.setState({
      loginSuccessData,
      clientId: tokenDetails?.user?.client_id || "",
      userId: tokenDetails?.user?.id || "",
    });

    this.timerId = setTimeout(() => {
      this.setState({ showNotification: false });
    }, 15000);
  }

  handleSocketMessage = (event) => {
    try {
      let tokenDetails = decodeJWT(localStorage.getItem("token"));
      let data = event;
      if (data.msg === "LOGOUT_USER") {
        if (
          tokenDetails?.user?.client_id === parseInt(data.client_id) &&
          tokenDetails?.user?.auth_type !== "MAGIC_LINK"
        ) {
          this.setState({
            dailogModalHeader: (
              <span
                className="text-darkblue2 font-weight-bold"
                style={{ fontSize: "1.125rem" }}
              >
                Session Logged Out
              </span>
            ),
            dailogModalContent: (
              <p className="text-darkblue2 fs-15">
                Your session has been logged out due to a change in your
                authentication method. Please check your email to confirm the
                update and re-authenticate to continue.
              </p>
            ),
            confirmBtn: false,
            cancelBtn: false,
            isExpirationModalOpen: true,
          });
        }
      } else if (data.msg === "NEW_NOTIFICATION_BOARDS") {
        this.getNotificationList(); // no need for IIFE
      } else if (
        tokenDetails?.user?.id === parseInt(data.user_id) &&
        data.msg === "LOGOUT_USER_SESSION" &&
        tokenDetails?.user?.auth_type === "MAGIC_LINK"
      ) {
        this.setState({
          dailogModalHeader: (
            <span
              className="text-darkblue2 font-weight-bold"
              style={{ fontSize: "1.125rem" }}
            >
              Session Logged Out
            </span>
          ),
          dailogModalContent: (
            <p className="text-darkblue2 fs-15">
              Your session has been logged out because another session accessed
              your account. If this wasn’t you, please secure your account
              immediately.
            </p>
          ),
          confirmBtn: false,
          cancelBtn: false,
          isExpirationModalOpen: true,
        });
      }
    } catch (e) {
      console.error("WebSocket parsing error:", e);
    }
  };

  componentWillUnmount() {
    const { socketRef } = this.props;

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    // Cleanly remove WebSocket message listener if present
    if (socketRef?.current && this.handleSocketMessage) {
      try {
        socketRef.current.off("client-event", this.handleSocketMessage);
      } catch (err) {
        console.warn("⚠️ Failed to remove WebSocket listener:", err);
      }
    } else {
      console.warn(
        "⚠️ socketRef or handleSocketMessage was not available during unmount"
      );
    }

    // Clear interval if it's running
    if (this.tokenExpiryInterval) {
      clearInterval(this.tokenExpiryInterval);
      this.tokenExpiryInterval = null;
    }

    // Reset any countdown if needed
    this.countdown = 0;
  }

  waitForSocket = () => {
    const { socketRef } = this.props;

    const check = () => {
      if (socketRef?.current) {
        socketRef.current.on("client-event", this.handleSocketMessage);
      } else {
        // Try again after 100 ms
        setTimeout(check, 100);
      }
    };

    check();
  };

  handleRequestNow = () => {
    const tokenDetails = decodeJWT(localStorage.getItem("token"));
    const userId = tokenDetails?.user?.id;

    MagicLinkUserServices.renewMagicLinkRequest(userId)
      .then((_res) => {
        let countdown = 5; // Start countdown from 5 seconds

        this.setState({
          isExpirationModalOpen: true, // Open modal before redirecting
          dailogModalHeader: (
            <span
              className="text-darkblue2 font-weight-bold"
              style={{ fontSize: "1.125rem" }}
            >
              Request Submitted
            </span>
          ),
          dailogModalContent: (
            <p className="text-darkblue2" style={{ fontSize: "14px" }}>
              Your request for renewal is submitted successfully to the
              authorized person! You will be redirected to login in {countdown}{" "}
              seconds. Thanks!
            </p>
          ),
          confirmBtn: false,
          cancelBtn: false,
        });

        // Start countdown timer
        const interval = setInterval(() => {
          countdown -= 1; // Decrease countdown by 1

          // Update modal content dynamically with remaining time
          this.setState({
            dailogModalContent: (
              <p className="text-darkblue2" style={{ fontSize: "14px" }}>
                Your request for renewal is submitted successfully to the
                authorized person! You will be redirected to login in{" "}
                {countdown} seconds. Thanks!
              </p>
            ),
          });

          if (countdown <= 0) {
            clearInterval(interval); // Stop interval when countdown ends

            // Clear token and redirect to login
            localStorage.removeItem("token");
            localStorage.clear();
            this.props.history.push(
              formatRoute(constants.APPLICATION_ROUTE.LOGIN.ROUTE)
            );
          }
        }, 1000); // Run every 1 second
      })
      .catch((error) => {
        Toast(
          error?.data?.error || constants.ERROR.SOMETHING_WENT_WRONG,
          "error"
        );
      });
  };

  handleDecline = () => {
    this.setState({
      dailogModalHeader: (
        <span
          className="text-darkblue2 font-weight-bold"
          style={{ fontSize: "1.125rem" }}
        >
          Session Expired
        </span>
      ),
      dailogModalContent: (
        <p className="text-darkblue2" style={{ fontSize: "14px" }}>
          You have declined the request. You will be redirected to the login
          page in {this.countdown} seconds.
        </p>
      ),
      confirmBtn: false,
      cancelBtn: false,
      isExpirationModalOpen: true, // Open modal before redirecting
    });

    // Start countdown timer
    const interval = setInterval(() => {
      this.countdown -= 1; // Decrease countdown by 1

      // Update modal content dynamically with remaining time
      this.setState({
        dailogModalContent: (
          <p className="text-darkblue2" style={{ fontSize: "14px" }}>
            You have declined the request. You will be redirected to the login
            page in {this.countdown} seconds.
          </p>
        ),
      });

      if (this.countdown <= 0) {
        clearInterval(interval); // Stop an interval when the countdown ends

        // Clear token and redirect to log in
        localStorage.clear();
        this.props.history.push(
          formatRoute(constants.APPLICATION_ROUTE.LOGIN.ROUTE)
        );
      }
    }, 1000); // Run every 1 second
  };

  handleOutsideClick(e) {
    if (e && e.target && this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.toggleProfileMenu();
    }
  }

  toggleProfileMenu = () => {
    if (!this.state.isProfileMenu) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }
    this.setState({
      isProfileMenu: !this.state.isProfileMenu,
    });
  };

  userLogout = () => {
    UserServices.getUserLogout()
      .then((_res) => {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("display_name");
        localStorage.removeItem("designation");
        localStorage.removeItem("clientId");
        localStorage.clear();
        this.props.loginSuccess({});
        React_GA_Intialise(null);
        ReactGA.gtag("set", "send_page_view", false);
        this.props.history.push(
          formatRoute(constants.APPLICATION_ROUTE.LOGIN.ROUTE, {})
        );
      })
      .catch((error) => {
        Toast(
          error && error.data && error.data.error
            ? error.data.error
            : constants.ERROR.SOMETHING_WENT_WRONG,
          "error"
        );
      });
  };

  handlePopUp = () => {
    this.setState({
      successMessage: "",
      apiErrors: "",
      popUpModel: !this.state.popUpModel,
      isSubmitted: false,
    });
  };

  // pop up for change display name
  handleNamePopUp = () => {
    this.setState({
      popUpNameModel: !this.state.popUpNameModel,
      isTrueVal: true,
      displayName_id: this.props.home.loginUserSuccess.id,
    });
  };

  // pop up for Api Credentials
  handleApiCredPopUp = () => {
    this.getApiCredential();
    this.setState({
      popUpApiCredentials: !this.state.popUpApiCredentials,
      isTrueVal: true,
    });
  };

  isNameValid = (name) => {
    const regex = new RegExp(constants.REG_EX.NAME_REG_EX);
    return regex.test(name);
  };

  handleNameInputChange = (e) => {
    const { value } = e.target;
    const isTrueVal = !value || this.isNameValid(value);
    this.setState({
      newDisplayName: value,
      isTrueVal,
    });
  };

  handleInputChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (this.state.isSubmitted) this.isFormValid();
      }
    );
  };

  isFormValid = () => {
    let isNewPasswordCurrentPasswordEqualError =
      this.state.newPassword === this.state.currentPassword &&
      this.state.newPassword &&
      this.state.currentPassword;
    this.setState({
      isNewPasswordCurrentPasswordEqualError,
      isSubmitted: true,
    });
    return !isNewPasswordCurrentPasswordEqualError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.isFormValid()) {
      let body = {
        password: this.state.currentPassword,
        new_password: this.state.newPassword,
        confirm_password: this.state.confirmPassword,
      };
      UserServices.changePassword(body)
        .then((data) => {
          this.setState({
            apiErrors: "",
            successMessage: data.data.message,
          });
          setTimeout(() => {
            this.userLogout();
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            apiErrors:
              error && error.data && error.data.error
                ? error.data.error
                : constants.ERROR.SOMETHING_WENT_WRONG,
          });
        });
    }
  };

  // function change display name
  handleNameSubmit = (e) => {
    e.preventDefault();
    let body = {
      display_name: this.state.newDisplayName,
      id: this.state.displayName_id,
    };
    UserServices.updateDisplayName(body)
      .then((data) => {
        this.setState({
          apiErrors: "",
          successMessage: data.data.message,
          display_name: this.state.newDisplayName,
        });
        localStorage.setItem("display_name", this.state.newDisplayName);
        this.props.setDisplayName(this.state.newDisplayName);
        setTimeout(() => {
          this.handleNamePopUp();
          this.setState({ newDisplayName: "", successMessage: "" });
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          apiErrors:
            error && error.data && error.data.error
              ? error.data.error
              : constants.ERROR.SOMETHING_WENT_WRONG,
        });
      });
  };

  // function to generate API Credentials
  handleApiCredGeneration = (e) => {
    e.preventDefault();
  };
  // Calling an api for generating api credentials
  generateAPIKeyCred = () => {
    let body = {
      client_id: this.state.clientId,
      user_id: this.state.userId,
    };
    ApiCredentialServices.generateApiCredentials(body)
      .then((data) => {
        this.setState({
          apiErrors: "",
          secretKey: data?.data?.data?.api_secret,
          APIKey: data?.data?.data?.api_key,
        });
        Toast("API Key and Secret Generated Successfully.", "success");
      })
      .catch((error) => {
        this.setState({
          apiErrors:
            error && error.data && error.data.error
              ? error.data.error
              : constants.ERROR.SOMETHING_WENT_WRONG,
        });
      });
  };

  // Calling an api for re-generating api credentials
  regenerateApiCredentials = () => {
    let body = {
      client_id: this.state.clientId,
      user_id: this.state.userId,
    };
    ApiCredentialServices.regenerateApiCredentials(body)
      .then((data) => {
        this.setState({
          apiErrors: "",
          // successMessage: data?.data?.message,
          secretKey: data?.data?.data?.api_secret,
          APIKey: data?.data?.data?.api_key,
        });
        Toast(data?.data?.message, "success");
      })
      .catch((error) => {
        this.setState({
          apiErrors:
            error && error.data && error.data.error
              ? error.data.error
              : constants.ERROR.SOMETHING_WENT_WRONG,
        });
      });
  };

  // Calling an api for getting api credentials
  getApiCredential = () => {
    let body = {
      is_active: true,
    };
    ApiCredentialServices.getApiCredential(body)
      .then((data) => {
        if (data?.data?.data) {
          this.setState({
            APIKey: data?.data?.data?.api_key,
            secretKey: data?.data?.data?.api_secret,
            is_user_active: data?.data?.data?.is_active,
          });
        } else {
          this.setState({
            APIKey: null,
            secretKey: null,
            is_user_active: true,
          });
        }
      })
      .catch((error) => {
        this.setState({
          apiErrors:
            error && error.data && error.data.error
              ? error.data.error
              : constants.ERROR.SOMETHING_WENT_WRONG,
        });
      });
  };

  // navigate to the Preference center
  navigateToPreferenceCenter = () => {
    this.props.history.push(
      formatRoute(constants.APPLICATION_ROUTE.MANAGE_PREFERENCES.ROUTE, {})
    );
    this.toggleProfileMenu();
  };

  // navigate to user management
  navigateToUserManagement = () => {
    this.props.history.push(
      formatRoute(constants.APPLICATION_ROUTE.CLIENT_USER.LIST.ROUTE, {})
    );
    this.toggleProfileMenu();
  };

  getNotificationList = async () => {
    await HeaderNotificationService.getNotificationList()
      .then((result) => {
        this.props.notifications(result?.data?.notifications || []);
      })
      .catch((error) => {
        Toast(
          error && error.data && error.data.error
            ? error.data.error
            : constants.ERROR.SOMETHING_WENT_WRONG,
          "error"
        );
        console.error("Get Notification Error: ", error);
      });
  };

  render() {
    let pathName = window.location.pathname;
    let tokenDetails = decodeJWT(localStorage.getItem("token"));
    let { APIKey, secretKey, is_user_active } = this.state;
    const client_verification_status = localStorage.getItem(
      "client_verification_status"
    );
    const samlMode =
      tokenDetails.client?.verification_status || client_verification_status
        ? SAML_CONSTANTS.CONFIGURATION_SAML.MODE.EDIT_SAML_DETAILS
        : SAML_CONSTANTS.CONFIGURATION_SAML.MODE.SETUP_SAML_DETAILS;

    return (
      <>
        <header>
          <div className="header-content-wrapper h-100">
            <div className="header-content h-100 d-flex align-items-center">
              <nav className="navbar navbar-expand-lg navbar-light p-0">
                <div className="logo d-flex align-items-center">
                  <a
                    onClick={() => {
                      this.props.openSearchBar(false);
                    }}
                    // onClick={() => {
                    //   this.props.openPreference(false);
                    // }}
                    className="navbar-brand m-0 nav_logo"
                    href={formatRoute(
                      constants.APPLICATION_ROUTE.DASHBOARD_LIST.ROUTE,
                      {}
                    )}
                  >
                    <img
                      style={{ width: "80px" }}
                      src="https://tbr-ggk.s3.us-east-2.amazonaws.com/staging/TBR_2color_no_tagline.svg"
                      alt="TBR logo"
                    />
                    {/* <TBRLogo /> */}
                  </a>

                  <a
                    className="navbar-brand d-md-none header-logo"
                    href={formatRoute(
                      constants.APPLICATION_ROUTE.DASHBOARD_LIST.ROUTE,
                      {}
                    )}
                  >
                    <img
                      style={{ width: "80px" }}
                      src="https://tbr-ggk.s3.us-east-2.amazonaws.com/staging/TBR_2color_no_tagline.svg"
                      alt="TBR logo"
                    />
                    {/* <TBRLogo /> */}
                  </a>
                </div>
                {tokenDetails?.role?.short_name === "admin" && (
                  <div>
                    <ToggleSwitch data={this.state.loginSuccessData} />
                  </div>
                )}
                <div className="site_name ml-md-auto">
                  <span>INSIGHT CENTER</span>
                </div>

                <div className="ml-auto">
                  <div className="">
                    <div className="login_sec">
                      <ul className="navbar-nav justify-content-end align-items-center">
                        {tokenDetails?.user?.auth_type === "MAGIC_LINK" &&
                          tokenDetails?.user?.expire_in && (
                            <div className="ml-auto">
                              <MagicLinkTimer />
                            </div>
                          )}
                        {pathName !== "/dashboard/list" && (
                          <li className="mr-3">
                            <div
                              className="input_search d-flex align-items-center justify-content-center"
                              onClick={this.props.changepopover}
                            >
                              <i
                                className="fa fa-search text-grey-clr"
                                aria-hidden="true"
                              ></i>
                              <span className="search_text">
                                Search Insight Center
                              </span>
                              <span className="slash_btn">
                                <span>/</span>
                              </span>
                            </div>
                          </li>
                        )}

                        <HeaderNotification
                          getNotificationList={() => this.getNotificationList()}
                        />

                        <li className="mr-3">
                          <Button
                            id="PopoverLegacy"
                            style={{
                              padding: 0,
                              border: "none",
                              background: "none",
                              boxShadow: "none",
                            }}
                            type="button"
                            className="d-inline-flex"
                            data-testid="popover"
                          >
                            <span className="material-icons text-ligntblue2">
                              mail
                            </span>
                          </Button>
                          <UncontrolledPopover
                            placement="bottom"
                            target="PopoverLegacy"
                            trigger="legacy"
                            className="custom-popover"
                          >
                            <PopoverHeader>Email Support</PopoverHeader>
                            <PopoverBody>
                              Any queries/help, please contact us <br />
                              <a
                                style={{ color: "#0645AD" }}
                                href="mailto:icsupport@tbri.com"
                                data-testid="emailanchortag"
                              >
                                icsupport@tbri.com
                              </a>
                            </PopoverBody>
                          </UncontrolledPopover>
                        </li>
                        <li
                          onClick={this.toggleProfileMenu}
                          className={`user-details mr-0 ${
                            this.state.isProfileMenu ? "active" : ""
                          }`}
                        >
                          <div className="d-flex align-items-center">
                            <span className="profile_circle">
                              {getFirstLetters(
                                `${this.props.home.loginUserSuccess?.first_name} ${this.props.home.loginUserSuccess?.last_name}`
                              )}
                            </span>
                            <div className="user-details-block d-none d-md-flex flex-column align-items-center">
                              <span className="w-100">
                                {ellipsisName(this.props.home?.displayName)}
                              </span>
                              <span className="user-role">
                                {this.props.home.loginUserSuccess?.designation
                                  ? this.props.home.loginUserSuccess
                                      ?.designation
                                  : ["Super Admin", "Admin"].includes(
                                      tokenDetails?.role?.name
                                    )
                                  ? "Admin"
                                  : tokenDetails?.role?.name}
                              </span>
                            </div>
                            <span className="material-icons arrow-drown-down">
                              arrow_drop_down
                            </span>
                          </div>
                        </li>
                        <li className="d-none">
                          <span className="search_open">
                            <i className="fa fa-search" aria-hidden="true"></i>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </header>
        <div
          className={`login_sec user-popover ${
            this.state.isProfileMenu ? "active" : ""
          }`}
          id="loginpopover"
        >
          <ul
            ref={(node) => {
              this.node = node;
            }}
          >
            <li>
              <div className="userProfile">
                <img src={profile_image} alt="Profile" />
                <h4>
                  {`${this.props.home.loginUserSuccess.first_name}${
                    this.props.home.loginUserSuccess.last_name
                      ? ` ${this.props.home.loginUserSuccess.last_name}`
                      : ""
                  }`}
                </h4>
                <div
                  data-for="displayNameUser"
                  data-tip={
                    this.state.display_name !== "null"
                      ? this.state.display_name
                      : "N/A"
                  }
                >
                  <CustomReactTooltip id="displayNameUser" />
                  <p>
                    Display Name:{" "}
                    {this.state.display_name !== "null"
                      ? ellipsisName(this.state.display_name)
                      : "N/A"}
                  </p>
                </div>
                {tokenDetails && tokenDetails?.role && (
                  <span className="user-profile-role">
                    {this.props.home.loginUserSuccess.designation !== null
                      ? this.props.home.loginUserSuccess.designation
                      : ["Super Admin", "Admin"].includes(
                          tokenDetails?.role?.name
                        )
                      ? "Admin"
                      : tokenDetails?.role?.name}
                    {tokenDetails?.client && tokenDetails?.client?.name
                      ? ` - ${tokenDetails?.client?.name}`
                      : ""}
                  </span>
                )}
                <p>
                  Member Since{" "}
                  {DateTimeFormatter(
                    this.props.home.loginUserSuccess.created_at
                  )}
                </p>
              </div>
            </li>
            <li>
              <span
                onClick={this.handleNamePopUp}
                className="d-inline-flex align-items-center"
                data-testid="chnagenamebtn"
              >
                <i className="material-icons-outlined">account_circle</i>
                Change Display Name
              </span>
            </li>
            {this.state.popUpNameModel && (
              <Modal
                isOpen={this.state.popUpNameModel}
                toggle={this.handleNamePopUp}
                className={"modal-md modal-w-header custom-modal primary-modal"}
                data-testid="modalpopup"
              >
                <ModalHeader toggle={this.handleNamePopUp}>
                  {constants.CHANGE_NAME.HEADER_TITLE}
                </ModalHeader>
                <form
                  onSubmit={this.handleNameSubmit}
                  className={`col-lg-12 col-sm-12 form-wrapper p-0`}
                >
                  <ModalBody>
                    {this.state.apiErrors.length > 0 && (
                      <Notification
                        color={"danger"}
                        message={this.state.apiErrors}
                      />
                    )}
                    {this.state.successMessage.length > 0 && (
                      <Notification
                        color={"success"}
                        message={this.state.successMessage}
                      />
                    )}
                    <FormGroup>
                      <Label htmlFor="currentPassword">
                        Current Display Name
                      </Label>
                      <Input
                        type="text"
                        disabled={true}
                        value={this.state.display_name}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="newPassword">
                        New Display Name
                        <span className={"mandatory"}>* </span>
                      </Label>
                      <Input
                        className={`${
                          !this.state.isTrueVal ? "is-invalid" : ""
                        }`}
                        type="text"
                        placeholder=""
                        id="newDisplayName"
                        name="newDisplayName"
                        onChange={this.handleNameInputChange}
                        value={this.state.newDisplayName}
                      />
                      {!this.state.isTrueVal && (
                        <div className="invalid-tooltip">{`${this.state.newDisplayName} is not valid.`}</div>
                      )}
                    </FormGroup>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      className="modal-btn btn-outline-primary"
                      onClick={this.handleNamePopUp}
                      data-testid="cancelbtn"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="modal-btn"
                      color="primary"
                      type="submit"
                      role="submit"
                      disabled={
                        this.state.newDisplayName.length === 0 ||
                        !this.state.isTrueVal
                      }
                    >
                      Change Name
                    </Button>
                  </ModalFooter>
                </form>
              </Modal>
            )}
            {Number(tokenDetails?.client?.is_open_api_active) === 1 && (
              <>
                <li>
                  <span
                    onClick={this.handleApiCredPopUp}
                    className="d-inline-flex align-items-center"
                    data-testid="apicredbtn"
                  >
                    <i
                      className="material-icons-outlined"
                      style={{ rotate: "90deg", paddingRight: "0px" }}
                    >
                      key
                    </i>
                    API Credentials
                  </span>
                </li>

                {this.state.popUpApiCredentials && (
                  <Modal
                    isOpen={this.state.popUpApiCredentials}
                    toggle={this.handleApiCredPopUp}
                    className="modal-md modal-w-header custom-modal primary-modal"
                    data-testid="modalpopup"
                  >
                    <ModalHeader toggle={this.handleApiCredPopUp}>
                      {constants.API_CREDENTIAL_TITLE.HEADER_TITLE}
                    </ModalHeader>
                    {is_user_active ? (
                      <form
                        onSubmit={this.handleApiCredGeneration}
                        className="col-lg-12 col-sm-12 form-wrapper p-0"
                      >
                        <ModalBody className="pb-2">
                          {this.state.apiErrors.length > 0 && (
                            <Notification
                              color={"danger"}
                              message={this.state.apiErrors}
                            />
                          )}
                          {this.state.successMessage.length > 0 && (
                            <Notification
                              color={"success"}
                              message={this.state.successMessage}
                            />
                          )}
                          <FormGroup>
                            <Label
                              htmlFor="endpoint"
                              style={{ color: "black" }}
                            >
                              Endpoint
                            </Label>
                            <div
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Input
                                type="text"
                                value={process.env.REACT_APP_TBRI_OPEN_API_URL}
                                disabled
                              />
                              <span
                                className="material-icons-outlined copy-icon icon-fs-14 p-2 cursor-pointer"
                                aria-hidden="true"
                                onClick={() => {
                                  Copy(process.env.REACT_APP_TBRI_OPEN_API_URL);
                                  Toast(
                                    "Copied Endpoint Successfully",
                                    "success"
                                  );
                                }}
                                data-for="tooltip-copy-endpoint"
                                data-tip="Copy<br>Endpoint"
                                data-iscapture="true"
                              >
                                content_copy
                              </span>
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <Label htmlFor="APIKey" style={{ color: "black" }}>
                              API Key
                            </Label>
                            <div
                              style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Input
                                className={
                                  !this.state.isTrueVal ? "is-invalid" : ""
                                }
                                type="text"
                                id="APIKey"
                                name="APIKey"
                                value={APIKey}
                                disabled
                              />
                              <span
                                className="material-icons-outlined copy-icon icon-fs-14 p-2 cursor-pointer"
                                aria-hidden="true"
                                onClick={() => {
                                  Copy(APIKey);
                                  Toast(
                                    "Copied APIKey Successfully",
                                    "success"
                                  );
                                }}
                                data-for="tooltip-copy-APIKey"
                                data-tip="Copy<br>APIKey"
                                data-iscapture="true"
                              >
                                content_copy
                              </span>
                              <CustomReactTooltip
                                id="tooltip-copy-APIKey"
                                multiline
                              />
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <Label
                              htmlFor="secretKey"
                              style={{ color: "black" }}
                            >
                              API Secret Key
                            </Label>
                            <div className="d-flex align-items-center">
                              <Input
                                className={
                                  !this.state.isTrueVal ? "is-invalid" : ""
                                }
                                type="text"
                                id="secretKey"
                                name="secretKey"
                                value={secretKey}
                                disabled
                              />
                              <span
                                className="material-icons-outlined copy-icon icon-fs-14 p-2 cursor-pointer"
                                aria-hidden="true"
                                onClick={() => {
                                  Copy(secretKey);
                                  Toast(
                                    "Copied API Secret Key Successfully",
                                    "success"
                                  );
                                }}
                                data-for="tooltip-copy-secretKey"
                                data-tip="Copy<br>SecretKey"
                                data-iscapture="true"
                              >
                                content_copy
                              </span>
                              <CustomReactTooltip
                                id="tooltip-copy-secretKey"
                                multiline
                              />
                            </div>
                          </FormGroup>
                        </ModalBody>
                        <div className="d-flex justify-content-center">
                          <Button
                            className="modal-btn btn-outline-primary"
                            onClick={
                              APIKey && secretKey
                                ? this.regenerateApiCredentials
                                : this.generateAPIKeyCred
                            }
                            data-testid="cancelbtn"
                          >
                            {APIKey && secretKey ? "Regenerate" : "Generate"}
                          </Button>
                        </div>
                        <span className="d-flex mt-3 justify-content-center">
                          View API documentation and examples on{" "}
                          <a
                            href={
                              process.env.REACT_APP_TBRI_OPEN_API_URL +
                              "/api-docs"
                            }
                            rel="noreferrer"
                            className="ml-2 font-weight-bold"
                            style={{ color: "#046CD9", fontSize: "14px" }}
                            target="_blank"
                          >
                            Swagger
                          </a>
                        </span>
                      </form>
                    ) : (
                      <ModalBody>
                        <div
                          className="noaccess-body mt-2"
                          style={{ alignItems: "center" }}
                        >
                          <p
                            className="font-weight-semibold"
                            style={{ fontSize: "16px", color: "#626262" }}
                          >
                            You don't have access to the API credentials page.
                            Please contact the administrator for access.
                          </p>
                        </div>
                      </ModalBody>
                    )}
                    {!is_user_active && (
                      <ModalFooter>
                        <div className="d-flex justify-content-center">
                          <Button
                            className="modal-btn btn-outline-primary"
                            onClick={this.handleApiCredPopUp}
                            data-testid="cancelbtn"
                          >
                            Cancel
                          </Button>
                        </div>
                      </ModalFooter>
                    )}
                  </Modal>
                )}
              </>
            )}
            <AclAction
              type={constants.ACL.PERMISSION_KEY}
              entity={constants.ACL.CLIENT_USER_MANGEMENT.TITLE}
              action={constants.ACL.CLIENT_USER_MANGEMENT.ACTIONS.SHOW}
            >
              <li tbrentitytype={constants.ACL.ENTITY_TYPE.BUTTON}>
                <span
                  onClick={this.navigateToUserManagement}
                  className="d-inline-flex align-items-center"
                  data-testid="user-managment"
                >
                  <i className="material-icons-outlined">people</i>
                  User Management
                </span>
              </li>
            </AclAction>

            {Number(tokenDetails?.user?.is_set_password) === 1 && (
              <li>
                <span
                  onClick={this.handlePopUp}
                  className="d-inline-flex align-items-center"
                  data-testid="chnagepwdbtn"
                >
                  <i className="material-icons-outlined">lock_res et</i>
                  Change Password
                </span>
              </li>
            )}

            {this.state.popUpModel && (
              <Modal
                isOpen={this.state.popUpModel}
                toggle={this.handlePopUp}
                className={"modal-md modal-w-header custom-modal primary-modal"}
                data-testid="modalpopup"
              >
                <ModalHeader toggle={this.handlePopUp}>
                  {constants.CHANGE_PASSWORD.HEADER_TITLE}
                </ModalHeader>
                <form
                  onSubmit={this.handleSubmit}
                  className={`col-lg-12 col-sm-12 form-wrapper p-0`}
                >
                  <ModalBody>
                    {this.state.apiErrors.length > 0 && (
                      <Notification
                        color={"danger"}
                        message={this.state.apiErrors}
                      />
                    )}
                    {this.state.successMessage.length > 0 && (
                      <Notification
                        color={"success"}
                        message={this.state.successMessage}
                      />
                    )}
                    <FormGroup>
                      <Label htmlFor="currentPassword">
                        Current Password
                        <span className={"mandatory"}>* </span>
                      </Label>
                      <Input
                        type="password"
                        placeholder=""
                        id="currentPassword"
                        name="currentPassword"
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="newPassword">
                        New Password
                        <span className={"mandatory"}>* </span>
                      </Label>
                      <Input
                        className={`${
                          this.state.isNewPasswordCurrentPasswordEqualError
                            ? "is-invalid"
                            : ""
                        }`}
                        type="password"
                        placeholder=""
                        id="newPassword"
                        name="newPassword"
                        onChange={this.handleInputChange}
                      />
                      {this.state.isNewPasswordCurrentPasswordEqualError && (
                        <div className="invalid-tooltip">
                          Current Password and New Password should be different{" "}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor="confirmPassword">
                        Confirm Password
                        <span className={"mandatory"}>* </span>
                      </Label>
                      <Input
                        type="password"
                        placeholder=""
                        id="confirmPassword"
                        name="confirmPassword"
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>
                    <PasswordChecklist
                      rules={[
                        "minLength",
                        "specialChar",
                        "number",
                        "capital",
                        "match",
                        "notEmpty",
                        "lowercase",
                      ]}
                      minLength={8}
                      value={this.state.newPassword}
                      iconSize={12}
                      valueAgain={this.state.confirmPassword}
                      onChange={(isValid) => {
                        this.setState({
                          isChecklistValid: isValid,
                        });
                      }}
                      style={{ marginTop: "20px" }}
                      className={"set-pwd-form"}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      className="modal-btn btn-outline-primary"
                      onClick={this.handlePopUp}
                      data-testid="cancelbtn"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="modal-btn"
                      color="primary"
                      type="submit"
                      role="submit"
                      disabled={!this.state.isChecklistValid}
                    >
                      Change Password
                    </Button>
                  </ModalFooter>
                </form>
              </Modal>
            )}

            {Number(tokenDetails?.client?.is_saml) === 1 && (
              <AclAction
                type={constants.ACL.PERMISSION_KEY}
                entity={SAML_CONSTANTS.ACL.SAML_CONFIGURATION.TITLE}
                action={SAML_CONSTANTS.ACL.SAML_CONFIGURATION.ACTIONS.SHOW}
              >
                <li tbrentitytype={constants.ACL.ENTITY_TYPE.BUTTON}>
                  <span
                    onClick={() => {
                      this.setState({ showSamlConfig: true });
                    }}
                    className="d-inline-flex align-items-center"
                  >
                    <i className="material-symbols-outlined">
                      settings_account_box
                    </i>
                    {tokenDetails?.client?.verification_status ||
                    client_verification_status
                      ? "Edit Configure SSO"
                      : "Configure SSO"}
                    {(tokenDetails?.client?.verification_status ||
                      client_verification_status) && (
                      <span
                        className="material-symbols-outlined text-success p-0 ml-2"
                        style={{ fontSize: "16px" }}
                      >
                        verified_user
                      </span>
                    )}
                  </span>
                  {this.state.showSamlConfig && (
                    <SamlConfiguration
                      mode={samlMode}
                      open={this.state.showSamlConfig}
                      close={() => this.setState({ showSamlConfig: false })}
                    />
                  )}
                </li>
              </AclAction>
            )}

            <li>
              <span
                onClick={this.navigateToPreferenceCenter}
                className="d-inline-flex align-items-center"
              >
                <i className="material-icons-outlined">settings</i>
                Preferences Center
              </span>
            </li>

            <li>
              <span
                onClick={this.userLogout}
                className="d-inline-flex align-items-center"
                id="logoutbtn"
              >
                <i className="material-icons-outlined icon-fs-20 font-weight-bold">
                  logout
                </i>
                Logout
              </span>
            </li>
          </ul>
          {this.state.isExpirationModalOpen && (
            <DailogNew
              isOpen={this.state.isExpirationModalOpen}
              accept={this.handleRequestNow}
              decline={this.handleDecline}
              header={this.state.dailogModalHeader}
              content={this.state.dailogModalContent}
              config={this.state.dailogModalConfig}
              modalStyleType={"success-modal"}
              cancel={this.state.cancelBtn}
              submit={this.state.confirmBtn}
              submitButtonLabel={this.state.submitButtonLabel}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    home: state.home,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    loginSuccess: (user) => {
      dispatch(loginUserSuccess(user));
    },
    setDisplayName: (name) => {
      dispatch(displayName(name));
    },
    loginFailure: (user) => {
      dispatch(loginUserFailure(user));
    },
    openSearchBar: (data) => {
      dispatch(openSearchBar(data));
    },
    notifications: (data) => {
      dispatch(notifications(data));
    },
  };
};
const ConnectedHeader = connect(mapStateToProps, mapDispatchToProps)(Header);
const HeaderWithWebSocket = (props) => (
  <WebSocketConsumer>
    {(socketRef) => {
      return <ConnectedHeader socketRef={socketRef} {...props} />;
    }}
  </WebSocketConsumer>
);

export default HeaderWithWebSocket;
